<template>
  <section class="selected-test-preview" id="toxicology-tests-preview">
    <div class="vue-tabs">
      <div v-if="getToxicActiveTab">
        <div v-if="showTab('TOXICOLOGY', ['SCREENING', 'SCREENING_VALIDITY'])">
          <div>
            <div class="custom-tabs-label">
              <span> Screening </span>
            </div>
          </div>
          <div class="test-panels-blocks">
            <ul>
              <li class="toxicology-text-panels" v-for="(category, index) of getCaseCategoryBasedData(
                test.case_type_code,
                ['SCREENING', 'SCREENING_VALIDITY']
              )" :key="index">
                <h3 class="test-group-title">{{ category.category }}</h3>
                <ul class="check-list-toxicology">
                  <li v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <span>
                      {{ item.test_name }}
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="
          showTab(
            'TOXICOLOGY',
            ['SCREENING', 'ETG_ETS', 'SCREENING_VALIDITY'],
            false
          )
        ">
          <div>
            <div class="custom-tabs-label">
              <span> Confirmation </span>
            </div>
          </div>
          <div class="test-panels-blocks">
            <ul>
              <li class="toxicology-text-panels" v-for="(category, index) of getCaseCategoryBasedData(
                test.case_type_code,
                ['SCREENING', 'ETG_ETS', 'SCREENING_VALIDITY'],
                false
              )" :key="index">
                <h3 class="test-group-title">{{ category.category }}</h3>
                <ul class="check-list-toxicology">
                  <li v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <span>{{ item.test_name }} </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="showTab('TOXICOLOGY', ['ETG_ETS'])">
          <div>
            <div class="custom-tabs-label">
              <span> ETG_ETS </span>
            </div>
          </div>
          <div class="test-panels-blocks">
            <ul>
              <li class="toxicology-text-panels" v-for="(category, index) of getCaseCategoryBasedData(
                test.case_type_code,
                ['ETG_ETS']
              )" :key="index">
                <h3 class="test-group-title">
                  {{ category.category }}
                </h3>
                <ul class="check-list-toxicology">
                  <li v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <span>{{ item.test_name }} </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper],
  props: ["panelTestsData", "test", "allSelectedTests"],
  data() {
    return {
      activeToxicologyTab: "screening",
      screeningChecked: false,
      confirmationChecked: false,
      etgChecked: false,
      activeNameCollapse: "",
      activeNameCollapseScreening: [0, 1],
      activeNameCollapseETG: [0],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: []
      },
      allTests: "",
    };
  },
  async mounted() {
    this.panelsTestsData = this.panelTestsData;

    // WE NEED TO APPEND PANEL CODE TO PANEL 

    this.panelsTestsData.selectedCategories = this.panelsTestsData.selectedCategories.map((e) => {
      e.panel_code = this.getPanelCodeByPanelId(e.panel_id)
      return e;
    })

    
    this.allTests = this.allSelectedTests;
    try {
      await this.$store.dispatch("labTests/fetchAllLabTests", {
        get_all: true,
        case_type_code: ["TOXICOLOGY"],
      });
      // eslint-disable-next-line no-empty
    } catch (err) { }
  },
  computed: {
    ...mapGetters("cases", ["getCaseInformation"]),
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }
      return data;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    getToxicActiveTab() {
      let toxic = this.selectedTestsDetails.filter(
        (x) => x.case_type_code == "TOXICOLOGY"
      );

      if (toxic.length) {
        let screeningFound = toxic.find(
          (test) => test.category.indexOf("Screening") > -1
        );
        let confirmationFound = toxic.find(
          (test) =>
            test.category.indexOf("Screening") == -1 &&
            test.category.indexOf("ETG/ETS") == -1
        );
        let etgEtsFound = toxic.find(
          (test) => test.category.indexOf("ETG/ETS") > -1
        );

        if (screeningFound) {
          return "screening";
        } else if (confirmationFound) {
          return "confirmation";
        } else if (etgEtsFound) {
          return "ETG_ETS";
        }
      }

      return "screening";
    },
  },
  methods: {


    getPanelCodeByPanelId(id) {
      return this.getNewLabGroupPanelTests.find((e) => e.panel_id == id)?.panel_code
    },
    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_code === category &&
            (el.test_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType && el.panel_code === category
        );
      }
      return this.sortByKey(data, "test_name");
    },

    showTab(caseType, category, include = true) {
      if (include) {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.category_code) != -1
        ).length
          ? true
          : false;
      } else {
        return this.selectedTestsDetails.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.category_code) == -1
        ).length
          ? true
          : false;
      }
    },
    // for toxicology
    getCaseCategoryBasedData(caseType, category, include = true) {

      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );


      if (include) {
        data = this.panelTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) != -1
        );
      } else {
        data = this.panelTestsData.selectedCategories.filter(
          (el) =>
            el.case_type_code === caseType &&
            category.indexOf(el.panel_code) == -1
        );
      }

      data = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return data;
    },
  },
};
</script>
<style lang="scss">
.test-panels-blocks {
  .toxicology-text-panels {
    padding: 10px 0;
    position: relative;
  }

  .toxicology-text-panels:not(:last-child):after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    border-bottom: 1px solid #e8e4e4;
  }

  .check-list-toxicology {
    display: grid;
    grid-template-columns: repeat(5, 19%);
    -moz-column-gap: 10px;
    column-gap: 10px;

    li {
      margin: 7px 0;

      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    .el-checkbox {
      height: auto;
    }

    .el-checkbox-group {
      .el-checkbox {
        height: 20px;
      }

      .el-checkbox__input .el-checkbox__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
        border-radius: 4px;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #273480;
        border-color: #ffffff;
        box-shadow: 0 0 0 1px #ced1d6;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }

      .el-checkbox__label {
        color: #34495e;
      }
    }
  }

  .test-group-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
  }
}
</style>
